import { ActionType, getType } from 'typesafe-actions';

import * as currentOrder from '../../actionCreators/currentOrder';

const initialState = null;

export default function (
  state: SurchargeInstruction[] | null = initialState,
  action: ActionType<typeof currentOrder>,
): SurchargeInstruction[] | null {
  switch (action.type) {
    case getType(currentOrder.resetOrder): {
      return initialState;
    }
    case getType(currentOrder.setOrderingProviderSurchargeInstructions): {
      const { value } = action.payload;
      return value || initialState;
    }
    case getType(currentOrder.applyBufferData): {
      const { orderingProviderSurchargeInstructions } = action.payload.value;
      return orderingProviderSurchargeInstructions === undefined
        ? state
        : orderingProviderSurchargeInstructions;
    }
    default:
      return state;
  }
}
